import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { BlanketAddProductSliderModelService } from '../add-product/blanket-add-product-slider-model.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { Subscription } from 'rxjs';
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-blanket-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  productList: any[] = [];
  productAllDataSource: any;
  expandedElement: any | null; // internal
  isProductNotAdded = true;
  selectedProductList = new Array();
  itemList = new Array();
  displayedColumns: string[] = ['checkbox', 'product', 'flashmsg', 'detail', 'quantity', 'orderUOM',/* 'productLine'*/ 'packageSize'];
  filterTypeList = [
    { label: 'Product Name', column: 'productName' },
    { label: 'Package Size', column: 'packageSize' },
    { label: 'Vendor', column: 'vendor' },
    /* { label: 'Product Line', column: 'productLine' },*/
    { label: 'Item Number', column: 'itemNumber' },
    { label: 'Active Ingredient', column: 'activeIngredients' },
    { label: 'GTIN', column: 'gtin' }
  ];

  selectAll = false;
  errorCount = 0;
  errorCountItemId: Array<number> = [];
  e5_error: string;
  e8_error: string;
  e9_error: string;
  plAccess = false;
  disclaimerMessage: string;

  constructor(
    public excelService: ExcelService,
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private loaderService: LoaderService,
    private blanketOrderService: BlanketOrderService,
    private blanketAddProductSliderModelService: BlanketAddProductSliderModelService,
    private commonService: CommonService
  ) {
  }

  // ngOnInit
  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    if (this.selectedProductList.length > 0) {
      let isValid = true;
      this.selectedProductList.forEach(x => {
        this.validateLineItem(x);
        if (x.lineErrors.errors.length > 0) {
          isValid = false;
        }
      });

      if (!isValid) {
        return false;
      }

      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.selectedProductList.length });
      this.toastrService.info('Product Added');
    }
    const data = Object.assign({}, this);
    this.blanketAddProductSliderModelService.setData<AddProductComponent>(data);
    this.blanketAddProductSliderModelService.BlanketClose();
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    this.isProductNotAdded = this.selectedProductList.length > 0 ? false : true;
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isSelected = !item.isSelected;
  }

  selectAllProduct() {
    this.selectAll = !this.selectAll;
    this.productAllDataSource.data.forEach(x => {
      if (this.selectAll) {
        this.validateLineItem(x);
        if (x.lineErrors.errors.length <= 0) {
          x.IsProductSelected = true;
        }
      }
      else {
        x.IsProductSelected = false;
      }
      this.keepRecords(x, true);
    });
    this.enableDisableAddProductBtn();
  }

  // Get all product based on filter
  getAllProducts(filters) {
    filters.shipToAccount = this.blanketAddProductSliderModelService.shipToAccount;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.blanketOrderService.getAllBlanketItemList(filters).subscribe((result: any) => {
      if (result && result.length > 0) {
        this.productList = result;
        const errorMessages = result[0].errorMessages;
        if (errorMessages.length > 0) {
          this.e5_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA05')[0].message;
          this.e8_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA08')[0].message;
          this.e9_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA09')[0].message;
        }

        this.errorCount = 0;
        this.errorCountItemId = [];

        this.productList.forEach(x => {
          x.showError = false;
          x.errorMessages = errorMessages;
          const selectedItem = this.selectedProductList.filter(y => y.itemNumber == x.itemNumber);

          if (selectedItem && selectedItem.length > 0) {
            x.quantity = selectedItem[0].quantity;
            x.IsProductSelected = true;
            if (x.lineErrors.errors.length > 0) {
              this.errorCount += 1;
            }
          }
          else {
            x.IsProductSelected = false;
          }
        });
      }
      else {
        this.toastrService.info('No records found.');
        this.productList = [];
      }
      this.productAllDataSource = new MatTableDataSource(this.productList);
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource([]);
      this.toastrService.error('No records found.');
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // unit change and validation
  orderUnitChange(action: string, productItem: any) {
    const palletConvF = productItem.palletConvF ? +productItem.palletConvF : 1;
    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.quantity;
        productItem.quantity = Math.floor(productItem.quantity / palletConvF) * palletConvF;
        if (valueBeforeDec == productItem.quantity) {
          productItem.quantity = (+productItem.quantity > palletConvF ? +productItem.quantity - palletConvF : 0);
        }
      }
      else {
        productItem.quantity = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.quantity;
      productItem.quantity = Math.ceil(productItem.quantity / palletConvF) * palletConvF;
      if (valueBeforeInc == productItem.quantity) {
        productItem.quantity = (+productItem.quantity + palletConvF);
      }
    }

    if (productItem.lineErrors.errors.length > 0 && productItem.IsProductSelected) {
      this.errorCount = this.errorCount > 0 ? this.errorCount - 1 : 0;
    }
    this.validateLineItem(productItem);

    this.keepRecords(productItem);
    this.enableDisableAddProductBtn();
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    if (productItem.lineErrors.errors.length > 0 && productItem.IsProductSelected) {
      this.errorCount = this.errorCount > 0 ? this.errorCount - 1 : 0;
    }

    this.validateLineItem(productItem);
    this.keepRecords(productItem);
    this.enableDisableAddProductBtn();
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should be greater than zero' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
    }

    if (item.quantity < item.convertedThresholdUnits) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'thresholdUnits');
      item.lineErrors.errors.push({ id: 'thresholdUnits', error: this.e5_error.replace('{0}', item.convertedThresholdUnits).replace('{1}', item.uom) });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'thresholdUnits');
    }

    if (item.quantity > 0 && item.palletConvF > 0 && item.quantity % item.palletConvF != 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      item.lineErrors.errors.push({ id: 'conv', error: this.e8_error.replace('{0}', item.palletConvF).replace('{1}', item.uom) });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
    }

    return item;
  }

  // Add or remove product from selected list
  selectProduct(element): void {
    element.IsProductSelected = !element.IsProductSelected;
    if (element.lineErrors.errors.length > 0 && element.IsProductSelected) {
      this.errorCount = this.errorCount > 0 ? this.errorCount - 1 : 0;
    }
    this.validateLineItem(element);
    if (element.lineErrors.errors.length > 0) {
      element.IsProductSelected = false;
    }
    this.keepRecords(element, true);
    this.enableDisableAddProductBtn();
  }

  showError(element) {
    if (element.lineErrors.errors.length > 0) {
      element.showError = true;
    }
    else {
      element.showError = false;
    }
    this.keepRecords(element, true);
  }

  // Filter Product GridData based on filter values
  filterProductGridData(filters) {
    if (filters.clearAll == false) {
      this.setAddProdTableHeight();
      if (!this.validateProductFilter(filters)) {
        this.toastrService.error('Value must greater than equal to 2 characters.');
        return true;
      }
      this.getAllProducts(filters);
    }
    else {
      this.productList = [];
      this.productAllDataSource = new MatTableDataSource(this.productList);
      filters.clearAll = false;

      const filter: any = {};
      this.setAddProdTableHeight();
      // this.getAllProducts(filter);
    }
    this.enableDisableAddProductBtn();
  }

  // Clear Grid data
  clearGridData(filters) {
    this.errorCount = 0;
    this.errorCountItemId = [];
    this.productList = [];
    this.productAllDataSource = new MatTableDataSource(this.productList);
  }

  // Update selected prodcut list
  keepRecords(product, notSetSelected?) {
    const itemNumber = product.itemNumber;

    if (product.lineErrors.errors.length > 0) {
      product.showError = true;
      product.IsProductSelected = !notSetSelected ? false : product.IsProductSelected;

      if (!this.errorCountItemId.find(x => x === product.itemId)) {
        this.errorCount += 1;
        this.errorCountItemId.push(product.itemId);
      }
    }
    else {
      product.showError = false;
      product.IsProductSelected = !notSetSelected ? true : product.IsProductSelected;

      if (this.errorCountItemId.find(x => x === product.itemId)) {
        this.errorCount -= 1;
        var index = this.errorCountItemId.indexOf(product.itemId);
        if (index !== -1) {
          this.errorCountItemId.splice(index, 1);
        }
      }
    }

    if (product.IsProductSelected) {
      this.itemList.push(itemNumber);
      const item = this.productList.filter(i => i.itemNumber == itemNumber);
      const duplicateData = this.selectedProductList.find(y => y.itemNumber == product.itemNumber);
      if (duplicateData == undefined) {
        this.selectedProductList.push(item[0]);
      }
    }
    else {
      var index = this.itemList.indexOf(itemNumber);    // <-- Not supported in <IE9
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      this.selectedProductList = this.selectedProductList.filter(i => i.itemNumber != itemNumber);
    }
    this.enableDisableAddProductBtn();
  }

  // set Add product table height
  setAddProdTableHeight() {
    const tableHeight = window.innerHeight - $('h3').outerHeight() - $('.form-sec ').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.prodTableContainer').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAddProdTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAddProdTableHeight();
  }

  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // to validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate MarketingBrand
    if (productFilter.itemNo != null && productFilter.itemNo.length > 0) {
      isValid = true;
    }

    // To Validate ProductName
    if (productFilter.productName !== null && productFilter.productName !== '' && productFilter.productName.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ActiveIngredient
    if (productFilter.activeIngredient !== null && productFilter.activeIngredient !== '' && productFilter.activeIngredient.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Vendor
    if (productFilter.vendor !== null && productFilter.vendor !== '' && productFilter.vendor.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Gtin
    if (productFilter.gtin !== null && productFilter.gtin !== '' && productFilter.gtin.toString().trim().length >= 2) {
      isValid = true;
    }
    // To Validate ProductLine
    if (productFilter.productLine !== null && productFilter.productLine !== '' && productFilter.productLine.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.packageSize !== null && productFilter.packageSize !== '' && productFilter.packageSize.toString().trim().length >= 2) {
      isValid = true;
    }

    if (productFilter.productName == null
      && (productFilter.itemNo == null || productFilter.itemNo.length <= 0)
      && productFilter.activeIngredient == null
      && productFilter.vendor == null
      && productFilter.gtin == null
      && productFilter.productLine == null
      && productFilter.packageSize == null) {
      isValid = false;
    }
    return isValid;
  }

  public exportProducts() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);
    if (this.productList && this.productList.length > 0) {
      const filteredList = this.productList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Code': x.itemNumber,
          'Product': x.itemDescription,
          'Quantity': x.quantity,
          'Order UOM': x.uom,
          'Product Line': x.productLine,
          'Package Size': x.packageSize,
          'Error': x.lineErrors.errors.length > 0 ? 'Yes' : 'No',
          'Selected': x.IsProductSelected == true ? 'Yes' : 'No',
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'BlanketProductsReport');
    }
    this.loaderService.setLoaderStatus(false);
  }

  getProductCount(type) {
    if (type == 'selected') {
      return this.selectedProductList.length;
    }
  }
}
